import { render, staticRenderFns } from "./putdmain.vue?vue&type=template&id=734259d9&scoped=true"
import script from "./putdmain.vue?vue&type=script&lang=js"
export * from "./putdmain.vue?vue&type=script&lang=js"
import style0 from "./putdmain.vue?vue&type=style&index=0&id=734259d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734259d9",
  null
  
)

export default component.exports